import { array, bool, func, object, string } from 'prop-types';
import useRoles from '../hooks/useRoles';
import RoleHeader from './RoleHeader';
import RoleList from './RoleList';
import RoleButtons from './RoleButtons';
import Collapse from '@mui/material/Collapse';
import sty from '../styles/Roles.module.css';
import LoadingBackdrop from 'components/LoadingBackdrop';

/**
 * @component Roles
 * @param { Object } props
 * @param { boolean } props.open
 * @param { object } props.state
 * @param { object } props.handler
 * @param { string } props.groupId
 * @param { array } props.selectedRoles
 * @param { array } props.roles
 * @param { function } props.onMenu
 * @param { boolean } props.trgRst
 * @returns { JSX.Element }
 */
function Roles(props) {
	const { state, handler } = useRoles(props);

	return (
		<Collapse className={sty.roles_collapse} in={props.open} timeout="auto" unmountOnExit>
			<section className={sty.roles_section}>
				<RoleHeader
					options={state.filteredRoles}
					IsDisabled={state.isDisabled}
					selected={state.chosenOptions}
					onOptions={handler.onOptions}
					onAdd={handler.onAdd}
					onDelete={handler.onDelete}
				/>
				<RoleList
					isCheckAll={state.isCheckAll}
					groupRoles={state.groupRoles}
					onCheck={handler.onCheck}
					onCheckAll={handler.onCheckAll}
					onHandle={handler.onHandle}
					onCreate={handler.onCreate}
				/>
				<RoleButtons
					onSave={handler.onSave}
					onReset={handler.onReset}
					onCreate={handler.onCreate}
				/>
			</section>
			<LoadingBackdrop open={state.loading} />
		</Collapse>
	);
}

Roles.propTypes = {
	open: bool,
	savingState: object,
	savingHandler: object,
	groupId: string,
	selectedRoles: array,
	roles: array,
	onMenu: func,
	trgRst: bool,
};

export default Roles;
